import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "region-dashboards-representative-abroad-base-info__body" }
const _hoisted_2 = { class: "region-dashboards-representative-abroad-base-info__titles" }
const _hoisted_3 = { class: "region-dashboards-representative-abroad-base-info__subtitle" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_RegionDashBoardsRepresentativeInfoList = _resolveComponent("RegionDashBoardsRepresentativeInfoList")!

  return (_openBlock(), _createElementBlock("section", {
    class: _normalizeClass(["region-dashboards-representative-abroad-base-info", { 'region-dashboards-representative-abroad-base-info_loading': _ctx.isLoading }])
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _cache[0] || (_cache[0] = _createElementVNode("h2", { class: "region-dashboards-representative-abroad-base-info__title" }, "Представитель за рубежом", -1)),
        _createElementVNode("h3", _hoisted_3, _toDisplayString(_ctx.getDisplayValue(_ctx.representativeAbroadInfo?.fullName)), 1)
      ]),
      _createVNode(_component_RegionDashBoardsRepresentativeInfoList, { representativeAbroadInfo: _ctx.representativeAbroadInfo }, null, 8, ["representativeAbroadInfo"])
    ])
  ], 2))
}